import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";

import { SHELL_OLD, decideShell } from "../../../redux/reducer/navFlags/navFlagsHelpers";
import { METRIKA_GOALS, trackMetrikaGoal } from "../../utilt/bootstrapAlert/yandexMetrica";

// Отдельно от PageV3.jsx: переключатель лежит в основной сборке (App.jsx), а стили
// новых страниц грузятся только вместе с самой страницей.
// Новая страница раздела или прежняя (rollout-plan.md, «Страницы по шагам»): новая — с новым
// меню, прежняя — когда всем включили старое меню. Если новая сломалась при отрисовке, на её
// месте сразу прежняя, а в Метрику уходит page_v3_fallback: человек не остаётся без раздела.
// Показываются ли новые страницы: то же решение, что у меню (ShellSwitch).
export function usePageV3On() {
  const flags = useSelector((state) => state.navFlagsReducer);
  return decideShell({ killed: flags?.killed, server: flags?.loaded ? flags.navV3 : null }) !== SHELL_OLD;
}

export default function PageV3Switch({ name, NewPage, OldPage }) {
  const on = usePageV3On();
  const [failed, setFailed] = useState(false);

  if (!on) return <OldPage />;
  // Обёртка раздела (wildberries.jsx, ozon.jsx) не даёт полей новой странице, поэтому
  // прежней странице на её месте поля нужны свои.
  if (failed) {
    return (
      <div style={{ padding: 16 }}>
        <OldPage />
      </div>
    );
  }

  return (
    <ErrorBoundary
      fallbackRender={() => (
        <div style={{ padding: 16 }}>
          <OldPage />
        </div>
      )}
      onError={(error) => {
        setFailed(true);
        trackMetrikaGoal(METRIKA_GOALS.pageV3Fallback, {
          page: name,
          message: String(error?.message || error || "").slice(0, 200),
          path: typeof window !== "undefined" ? window.location.pathname : undefined,
        });
      }}
    >
      <NewPage />
    </ErrorBoundary>
  );
}

